/* eslint-disable no-unreachable */
import { useMutation } from "@apollo/client";
import { Button, Form, Input, Radio, message } from "antd";
import { capitalize } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UPDATE_LEAD_EMAIL_LIST } from "../../../graphql/mutation";
import { updateLeadInList } from "../../../redux/slices/leadSlice";

export const EmailForm = ({ emailRef, setSelectedLead, emails = [] }) => {
  const [form] = Form.useForm();
  const emailTypes = ["PERSONAL", "WORK", "OTHER"];
  const [primaryEmailType, setprimaryEmailType] = useState(emailTypes[0]);
  const [emailData, setemailData] = useState(
    emails.map(email => ({ ...email, emailType: email.emailType || emailTypes[0] }))
  );
  const dispatch = useDispatch();
  const close = () => emailRef.current.click();
  const { selectedLead } = useSelector(state => state.lead);
  const [updateLeadEmail, { loading: updateLeadLoader }] = useMutation(UPDATE_LEAD_EMAIL_LIST);
  const saveEmail = async value => {
    const payload = {
      emails: emailData.map(item => ({ ...item, isPrimary: item.emailType === primaryEmailType })),
      leadId: selectedLead.id,
    };
    console.log(payload);
    const res = await updateLeadEmail({
      variables: {
        ...payload,
      },
    });
    if (res.data.updateLead.statusCode === 200) {
      message.success(res.data.updateLead.message);
      setSelectedLead({ ...selectedLead, ...res.data.updateLead.lead });
      dispatch(updateLeadInList(res.data.updateLead.lead));
      close();
    } else {
      message.error(res.data.updateLead.message);
    }
  };
  useEffect(() => {
    if (emails.length > 0) {
      const primaryEmail = emails.find(item => item.isPrimary);
      if (primaryEmail) {
        setprimaryEmailType(primaryEmail.emailType);
      }
    }
  }, [emails]);
  const getEmail = type => {
    const email = emailData.find(email => email.emailType === type);
    return email;
  };
  const serializeEmail = input => {
    const result = {};

    // Iterate over each object in the array
    input.forEach(item => {
      // Get the key of the current object (e.g., "Mobile" or "Work")
      const key = Object.keys(item)[0];
      // Assign the value to the result object
      result[item[key]] = item.email;
    });
    return result;
  };
  useEffect(() => {
    form.setFieldsValue(
      serializeEmail(emailData?.map(item => ({ emailType: item.emailType, email: item.email })))
    );
  }, [emailData]);
  const setEmail = (value, type) => {
    const index = emailData.findIndex(email => email.emailType === type);
    if (index !== -1) {
      setemailData(prev => {
        const temp = structuredClone(prev);
        temp[index] = {
          ...temp[index],
          email: value,
        };
        return temp;
      });
    } else {
      return setemailData([...emailData, { email: value, emailType: type }]);
    }
  };
  return (
    <Form layout="vertical" className="w-[300px]" form={form} onFinish={saveEmail}>
      <div className="flex-row-centered justify-end">
        <span>Primary</span>
      </div>
      <Radio.Group
        value={primaryEmailType}
        onChange={e => setprimaryEmailType(e.target.value)}
        className="flex-col-centered"
      >
        {emailTypes.map((item, index) => (
          <div key={index} className="flex-row-centered gap-2 justify-between w-full">
            <Form.Item
              rules={[
                {
                  required: primaryEmailType === item,
                  message: `Please enter the ${capitalize(item)} email`,
                },
                { type: "email", message: `Enter a valid ${capitalize(item)} email` },
              ]}
              label={`Email (${capitalize(item)})`}
              name={`${item}`}
              className="w-full"
            >
              <Input
                className="w-full"
                value={getEmail(item)?.email}
                onChange={e => setEmail(e.target.value, item)}
                name={`${item}`}
                placeholder={`Enter ${capitalize(item)} email`}
              />
            </Form.Item>
            <Radio className="mt-4" value={item} />
          </div>
        ))}
      </Radio.Group>
      <div className="flex-row-centered -m-3 px-3 py-2 mt-1 bg-grey-150 gap-1 items-center">
        <Button type="primary" loading={updateLeadLoader} htmlType="submit">
          Save
        </Button>
        <Button onClick={close}>Cancel</Button>
      </div>
    </Form>
  );
};
